"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCurrentTime = void 0;
const react_1 = require("react");
const moment_1 = __importDefault(require("moment"));
const useCurrentTime = () => {
    const [time, setTime] = (0, react_1.useState)((0, moment_1.default)());
    (0, react_1.useEffect)(() => {
        const timer = setInterval(() => {
            const nowMin = (0, moment_1.default)().minute();
            const getPreviousTime = () => time.minute(); // ABRAMOV CAN SUCK MY SOUSAGE
            if (getPreviousTime() !== nowMin) {
                setTime((0, moment_1.default)());
            }
        }, 2500);
        return () => {
            window.clearInterval(timer);
        };
    });
    return time;
};
exports.useCurrentTime = useCurrentTime;
